var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row-attachment" },
    [
      _vm.uploading.includes(_vm.index)
        ? _c("span", { staticClass: "button-sized-text" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("Attachment.Downloading")))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.attachment.fileNameWithExtension
        ? _c(
            "b",
            {
              class: {
                "button-sized-text": true,
                "validation-error": _vm.isDuplicatedFileName
              }
            },
            [_vm._v(_vm._s(_vm.attachment.fileNameWithExtension))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ValidationProvider", {
        attrs: {
          rules: { required: _vm.attachment.isRequired },
          mode: "aggressive",
          slim: ""
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              var failedRules = ref.failedRules
              return [
                _c("attachment-control", {
                  key: _vm.index,
                  class: _vm.getValidationErrorClasses(failedRules),
                  attrs: {
                    inputId: "attachment " + _vm.index,
                    settings: _vm.attachmentSettings,
                    required: _vm.attachment.isRequired,
                    "aria-invalid":
                      _vm.attachment.isRequired && errors.length > 0,
                    notifyonuploadedsuccess: _vm.notifyonuploadedsuccess
                  },
                  on: {
                    blur: _vm.blur,
                    "start-upload": function($event) {
                      return _vm.startUpload($event, _vm.index)
                    },
                    "stop-upload": function($event) {
                      return _vm.stopUpload($event, _vm.index)
                    },
                    "deleted-attachment": function($event) {
                      return _vm.deletedAttachment($event, _vm.attachment)
                    },
                    "added-attachment": function($event) {
                      return _vm.addedAttachment($event, _vm.attachment)
                    }
                  },
                  model: {
                    value: _vm.attachment.fileNameWithExtension,
                    callback: function($$v) {
                      _vm.$set(_vm.attachment, "fileNameWithExtension", $$v)
                    },
                    expression: "attachment.fileNameWithExtension"
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }